import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'


const SectionInfo = ({ site }) => {
    const defaultValues = {
        site_name: site?.site_name,
        admin_id: site?.admin_id,
        admin_mail: site?.admin_mail,
        admin_mail_title: site?.admin_mail_title,
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {        
        reset(defaultValues)
    }, [site])

    const onSubmit = async (data, e) => {
        const params = {
            "site_name": data.site_name,
            "admin_id": data.admin_id,
            "admin_mail": data.admin_mail,
            "admin_mail_title": data.admin_mail_title,
        };

        try {
            await apiService.put('/sites/general', params);
            toast.success('업데이트 되었습니다.')
        } catch (error) {
            console.error('Error updating site info:', error);
        }
    }

    return (
        site &&
        <Card>
            <CardHeader title='사이트 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="siteinfoform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='site_name'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='사이트제목'
                                            id='site_name'
                                            onChange={onChange}
                                            placeholder='사이트제목를 입력해주세요'
                                            error={Boolean(errors.site_name)}
                                            aria-describedby='validation-async-site_name'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.site_name && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-site_name'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='admin_id'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='최고관리자 ID'
                                            id='admin_id'
                                            onChange={onChange}
                                            placeholder='최고관리자 ID을 입력해주세요'
                                            error={Boolean(errors.admin_id)}
                                            aria-describedby='validation-async-admin_id'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.admin_id && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-admin_id'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='admin_mail'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            type='email'
                                            value={value || ''}
                                            label='관리자 메일주소'
                                            id='admin_mail'
                                            onChange={onChange}
                                            placeholder='관리자 메일주소를 입력해주세요'
                                            error={Boolean(errors.admin_mail)}
                                            aria-describedby='validation-async-admin_mail'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.admin_mail && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-admin_mail'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='admin_mail_title'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='관리자 메일 발송이름'
                                            id='admin_mail_title'
                                            onChange={onChange}
                                            placeholder='관리자 메일 발송이름를 입력해주세요'
                                            error={Boolean(errors.admin_mail_title)}
                                            aria-describedby='validation-async-admin_mail_title'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.admin_mail_title && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-admin_mail_title'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="siteinfoform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default SectionInfo
